<script setup>
import { ref } from 'vue'

const props = defineProps({
    errors: {
        type: [Object],
        default: {}
    },
});

</script>

<template>
    <div v-if="errors && Object.keys(errors).length">
        <div class="mt-4">
            <div
                v-for="error in errors"
                class="alert alert-danger alert-dismissible fade show"
                role="alert"
            >
                <div v-for="message in error">{{ message }}</div>
                <!-- <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>-->
            </div>
        </div>
    </div>
</template>

